<template>
  <div class="html" v-html="block.html" />
</template>

<script>
export default {
  props: {
    block: Object,
    blocks: Array,
    definitions: Array,
    state: String,
  },
};
</script>
